import { render, staticRenderFns } from "./ValidateFormButton.vue?vue&type=template&id=494b6d73&scoped=true&"
import script from "./ValidateFormButton.vue?vue&type=script&lang=js&"
export * from "./ValidateFormButton.vue?vue&type=script&lang=js&"
import style0 from "./ValidateFormButton.vue?vue&type=style&index=0&id=494b6d73&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b6d73",
  null
  
)

export default component.exports